const ITEMS = [
  "Private pool villas",
  "Breakfast & dinner included",
  "Sleeps 12 + 2",
  "Off Bannerghatta Road",
  "Six bedrooms each",
  "A short drive from the city",
];

export const Marquee = () => (
  <div
    data-testid="marquee"
    aria-hidden="true"
    className="overflow-hidden border-y border-brand-licorice/10 bg-brand-champagne py-5"
  >
    <div className="marquee-track flex w-max items-center whitespace-nowrap">
      {[...ITEMS, ...ITEMS, ...ITEMS, ...ITEMS].map((t, i) => (
        <span key={i} className="flex items-center font-serif text-xl font-light italic text-brand-sepia sm:text-2xl">
          <span className="px-8">{t}</span>
          <span className="h-1.5 w-1.5 rounded-full bg-brand-rust/50" />
        </span>
      ))}
    </div>
  </div>
);
